import * as React from "react";
const SvgFiRrUserNurse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 15c3.309 0 6-2.691 6-6V3c0-1.654-1.346-3-3-3H9C7.346 0 6 1.346 6 3v6c0 3.309 2.691 6 6 6m0-2c-2.206 0-4-1.794-4-4V8h8v1c0 2.206-1.794 4-4 4m4-10v3h-3V5h1a1 1 0 1 0 0-2h-1V2h2a1 1 0 0 1 1 1M8 3a1 1 0 0 1 1-1h2v1h-1a1 1 0 1 0 0 2h1v1H8zm13 20a1 1 0 1 1-2 0c0-1.823-.769-3.817-1.869-4.849a.5.5 0 0 0-.4-.144.62.62 0 0 0-.432.205l-3.518 4.411a1 1 0 0 1-1.563-.002l-3.543-4.457A.6.6 0 0 0 7.279 18a.52.52 0 0 0-.401.143c-1.105 1.032-1.877 3.029-1.877 4.856a1 1 0 1 1-2 0c0-2.413.986-4.893 2.512-6.317a2.49 2.49 0 0 1 1.86-.68 2.63 2.63 0 0 1 1.833.877l2.796 3.515 2.77-3.471a2.66 2.66 0 0 1 1.87-.914 2.52 2.52 0 0 1 1.858.683c1.519 1.424 2.5 3.9 2.5 6.308"
    />
  </svg>
);
export default SvgFiRrUserNurse;
